// utils/taskStatus.js
import axios from "axios";

export function getTaskDisplayStatus(task, statuses = {}) {
  const id = String(task.t_id);
  const key = String(task.t_key || "");
  const baseStatus = statuses[id] || statuses[key] || "not_completed";
  // The driver-license endpoint selects the active Primary. A higher-ID
  // historical/inactive license must never replace that authoritative status.
  if (Number(task.t_id) === 22 || key === "driver_license") return baseStatus;
  if (Number(task.t_requires_ref) === 1 && Number(task.t_show_list) !== 1) {
    const latest = Object.keys(statuses).filter((value) => value.startsWith(`${id}_`))
      .map((value) => ({ key: value, ref: Number(value.split("_")[1]) }))
      .filter((value) => Number.isFinite(value.ref))
      .sort((a, b) => b.ref - a.ref)[0];
    if (latest && statuses[latest.key]) return statuses[latest.key];
  }
  return baseStatus;
}

export function isTaskSignedStatus(status) {
  return status === "review" || status === "completed";
}

export function isTaskReviewedStatus(status) {
  return status === "completed" || status === "almost_expired";
}

/**
 * Fetch latest status for a "reference-based" task
 * (Work Permit, ADC, CVSA, Vacation, etc.)
 *
 * This ALWAYS sets status by both:
 *  - task key  (e.g. "passport")
 *  - task id   (e.g. "90")
 *
 * so UserHome icon logic works reliably.
 */
export async function fetchLatestTaskStatus({
  baseUrl,
  userId,
  endpoint, // e.g. "/api/passport/latest/status"
  taskId, // number (40, 57, etc.)
  taskKey, // string ("work_permit", "annual_driver_certification")
  token,
  baseStatus,
}) {
  if (!baseUrl || !userId || !endpoint || !taskId || !taskKey) {
    console.warn("⚠️ fetchLatestTaskStatus: missing required params", {
      baseUrl,
      userId,
      endpoint,
      taskId,
      taskKey,
    });
    return;
  }

  try {
    const res = await axios.get(`${baseUrl}${endpoint}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const status = res?.data?.status || "not_completed";

    // 🔑 critical: set BOTH key and id
    baseStatus[taskKey] = status;
    baseStatus[String(taskId)] = status;
  } catch (err) {
    console.error(
      `❌ Failed to fetch latest status for ${taskKey} (taskId=${taskId})`,
      err
    );
  }
}
